module.exports = "/static/assets/009d2bdb612e58522ac2847ed3be2ad9.png";